import styled from '@emotion/styled';

/** Centered horizontal row of pager controls rendered below a card grid. */
export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  padding: 16px 0;
`;

/** Numbered / Prev / Next pager button; `active` marks the current page. */
export const PageButton = styled.button<{ active?: boolean }>`
  padding: 8px 14px;
  font-size: 14px;
  font-weight: ${({ active }) => (active ? 600 : 400)};
  color: ${({ active }) => (active ? '#fff' : '#1a73e8')};
  background: ${({ active }) => (active ? '#1a73e8' : '#fff')};
  border: 1px solid ${({ active }) => (active ? '#1a73e8' : '#e0e0e0')};
  border-radius: 6px;
  cursor: pointer;
  transition:
    background 0.2s,
    color 0.2s;

  &:hover:not(:disabled) {
    background: ${({ active }) => (active ? '#1557b0' : '#f0f4ff')};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

/** Gap marker between non-adjacent page numbers. */
export const Ellipsis = styled.span`
  padding: 0 4px;
`;
